import React, { useEffect, useState, Component } from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { Check, Shield, Star, Heart, BookOpen, Sparkles, Clock, Gift, MessageCircle, Calendar, ChevronDown, ChevronUp } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
import { useCurrencyConversion } from '../hooks/useCurrencyConversion';
import { UpsellPopup } from './UpsellPopup';
interface BonusDetail {
  id: number;
  title: string;
  subtitle: string;
  value: string;
  description: string;
  benefits: string[];
  image: string;
  color: 'teal' | 'coral' | 'yellow';
  icon: ComponentType<{
    className?: string;
  }>;
}
const bonusDetails: BonusDetail[] = [{
  id: 1,
  title: 'Kit "Frases Anti-Berrinche"',
  subtitle: 'Bono #1 (GRATIS)',
  value: '$15.89',
  description: 'Guiones listos (de 10 segundos) para los momentos donde normalmente terminas gritando o negociando.',
  benefits: ['Saber qué decir cuando tu hijo se niega, grita o se tira al piso', 'Poner límites sin entrar en discusión', 'Volver al sistema rápido cuando el día se desordena'],
  image: 'https://cdn.magicpatterns.com/uploads/rAXJR4onxP682dgqe1keps/Bono_1.png',
  color: 'teal',
  icon: MessageCircle
}, {
  id: 2,
  title: 'Planner "Mañana en Calma" (7 días)',
  subtitle: 'Bono #2 (GRATIS)',
  value: '$15.89',
  description: 'Un plan simple para ordenar tus mañanas sin abrumarte: qué preparar, qué simplificar y cómo sostenerlo por una semana completa.',
  benefits: ['Dejar lista la mañana en pocos minutos (sin improvisar)', 'Instalar el hábito con un plan de 7 días', 'Tener una "rutina mínima" para días difíciles'],
  image: 'https://cdn.magicpatterns.com/uploads/42g7hVtv1ypRUDAPGu5QF8/Bono2.png',
  color: 'coral',
  icon: Calendar
}, {
  id: 3,
  title: 'Pack "Personaliza en 5 Min"',
  subtitle: 'Bono #3 (GRATIS)',
  value: '$15.89',
  description: 'Plantillas y recursos para personalizar el sistema con el nombre de tu hijo y lograr que se enganche más rápido (sin complicarte).',
  benefits: ['Hacer que tu hijo lo sienta suyo desde el día 1', 'Evitar peleas con elecciones limitadas (sin perder autoridad)', 'Aumentar cooperación sin sobornos'],
  image: 'https://cdn.magicpatterns.com/uploads/oTb3k9tDjAG9iVXQEAkGpm/Bono3.png',
  color: 'yellow',
  icon: Sparkles
}];
const colorStyles = {
  teal: {
    bg: 'bg-gradient-to-br from-[#E6F4F4] to-[#D4EFED]',
    border: 'border-[#4AAAA5]/20',
    badge: 'bg-[#4AAAA5]',
    icon: 'text-[#4AAAA5]',
    iconBg: 'bg-[#4AAAA5]/10'
  },
  coral: {
    bg: 'bg-gradient-to-br from-[#FFF5E6] to-[#FFEDD5]',
    border: 'border-[#E8845F]/20',
    badge: 'bg-[#E8845F]',
    icon: 'text-[#E8845F]',
    iconBg: 'bg-[#E8845F]/10'
  },
  yellow: {
    bg: 'bg-gradient-to-br from-[#FFFDF5] to-[#FFF9E6]',
    border: 'border-[#F5C842]/30',
    badge: 'bg-[#F5C842]',
    icon: 'text-[#D4A72C]',
    iconBg: 'bg-[#F5C842]/20'
  }
};
export function Pricing() {
  const [showBonusDetails, setShowBonusDetails] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [popupShown, setPopupShown] = useState(false);
  const {
    isLocal,
    localSymbol,
    localCode,
    countryFlag,
    convert
  } = useCurrencyConversion();
  const basePrice = 16.39;
  const baseOriginalPrice = 19.99;
  useEffect(() => {
    // Check if popup has been shown in this session
    const shown = sessionStorage.getItem('upsell_popup_shown');
    if (shown) {
      setPopupShown(true);
    }
  }, []);
  const handleBuyClick = (e: React.MouseEvent) => {
    e.preventDefault();
    if (!popupShown) {
      // Show popup for the first time
      setShowPopup(true);
      setPopupShown(true);
      sessionStorage.setItem('upsell_popup_shown', 'true');
    } else {
      // Redirect directly if already shown
      window.location.href = 'https://mundomamis.com/cart/43938138390637:1';
    }
  };
  return <Section background="teal" id="pricing" className="relative overflow-hidden" data-id="element-287">
      <UpsellPopup isOpen={showPopup} onClose={() => setShowPopup(false)} data-id="element-288" />

      {/* Background decoration */}
      <div className="absolute top-0 left-1/2 transform -translate-x-1/2 w-full h-full max-w-4xl opacity-10 pointer-events-none" data-id="element-289">
        <div className="absolute top-20 left-10 w-64 h-64 bg-[#F5C842] rounded-full blur-3xl" data-id="element-290"></div>
        <div className="absolute bottom-20 right-10 w-64 h-64 bg-[#E8845F] rounded-full blur-3xl" data-id="element-291"></div>
      </div>

      <div className="absolute top-16 left-8 text-[#F5C842] opacity-30 animate-float" data-id="element-292">
        <Star className="w-8 h-8 fill-current" data-id="element-293" />
      </div>
      <div className="absolute top-32 right-20 text-[#4AAAA5] opacity-20 animate-float" style={{
      animationDelay: '0.5s'
    }} data-id="element-294">
        <Sparkles className="w-6 h-6" data-id="element-295" />
      </div>
      <div className="absolute bottom-20 right-12 text-[#E8845F] opacity-30 animate-float" style={{
      animationDelay: '1.5s'
    }} data-id="element-296">
        <Heart className="w-7 h-7 fill-current" data-id="element-297" />
      </div>

      <div className="max-w-lg mx-auto relative z-10" data-id="element-298">
        <div className="text-center mb-8" data-id="element-299">
          <h2 className="text-2xl md:text-3xl font-extrabold text-gray-800 mb-2" data-id="element-300">
            Oferta Especial
          </h2>
          <span className="inline-flex items-center px-4 py-2 rounded-full bg-white/80 text-[#E8845F] font-bold text-sm shadow-sm" data-id="element-301">
            <Clock className="w-4 h-4 mr-2" data-id="element-302" />
            Descarga inmediata
          </span>
        </div>

        <div className="bg-white rounded-[2rem] shadow-2xl overflow-hidden border-4 border-[#F5C842]/30" data-id="element-303">
          {/* Header naranja */}
          <div className="bg-gradient-to-r from-[#E8845F] to-[#F5A574] p-5 text-center text-white relative" data-id="element-304">
            <div className="absolute -top-1 -right-1 bg-[#F5C842] text-gray-900 text-xs font-bold px-3 py-1 rounded-full transform rotate-12 shadow-md flex items-center" data-id="element-305">
              -68%
            </div>
            <h3 className="text-xl font-extrabold" data-id="element-306">Oferta de Lanzamiento</h3>
          </div>

          {/* Imagen del kit dentro de la caja */}
          <div className="p-4 pb-0" data-id="element-307">
            <div className="rounded-2xl overflow-hidden border-2 border-[#E6F4F4]" data-id="element-308">
              <img src="https://cdn.magicpatterns.com/uploads/csN58Nbj9T719GyQZvkfKA/kit.png" alt="Kit de Rutinas Visuales Anti-Berrinches" className="w-full h-auto object-cover" data-id="element-309" />
            </div>
          </div>

          {/* Precio y contenido */}
          <div className="p-6 pt-4" data-id="element-310">
            <div className="flex justify-center items-baseline mb-4" data-id="element-311">
              <span className="text-xl text-gray-400 line-through mr-2 transition-all duration-300" style={{
              fontVariantNumeric: 'tabular-nums'
            }} data-id="element-312">
                ${baseOriginalPrice.toFixed(2)}
              </span>
              <span className="text-5xl font-extrabold text-gray-800 transition-all duration-300" style={{
              fontVariantNumeric: 'tabular-nums'
            }} data-id="element-313">
                ${basePrice.toFixed(2)}
              </span>
              <span className="text-lg text-gray-400 ml-2 font-medium" data-id="element-314">
                USD
              </span>
            </div>

            {isLocal && <div className="flex justify-center mb-3 -mt-2" data-id="element-315">
                <span className="text-sm text-[#4AAAA5] font-semibold bg-[#E6F4F4] px-3 py-1 rounded-full inline-flex items-center gap-1.5" data-id="element-316">
                  {countryFlag} ≈ {localSymbol}
                  {convert(basePrice)} {localCode}
                </span>
              </div>}

            {/* Producto principal */}
            <div className="space-y-3 mb-4" data-id="element-317">
              <div className="flex items-center p-3 bg-gradient-to-r from-[#E6F4F4] to-[#D4EFED] rounded-xl border border-[#4AAAA5]/20" data-id="element-318">
                <div className="bg-gradient-to-br from-[#4AAAA5] to-[#5CBFBA] p-2 rounded-full mr-3 shadow-sm" data-id="element-319">
                  <Check className="w-4 h-4 text-white" data-id="element-320" />
                </div>
                <span className="font-bold text-gray-800 text-sm" data-id="element-321">
                  Kit imprimible Anti-Berrinches (PDF)
                </span>
              </div>

              <div className="flex items-center p-3 bg-gradient-to-r from-[#FFF5E6] to-[#FFEDD5] rounded-xl border border-[#E8845F]/20" data-id="element-322">
                <div className="bg-gradient-to-br from-[#E8845F] to-[#F5A574] p-2 rounded-full mr-3 shadow-sm" data-id="element-323">
                  <BookOpen className="w-4 h-4 text-white" data-id="element-324" />
                </div>
                <div data-id="element-325">
                  <span className="text-xs font-bold text-[#E8845F] uppercase" data-id="element-326">
                    REGALO
                  </span>
                  <p className="font-bold text-gray-800 text-sm" data-id="element-327">
                    Manual de Implementación
                  </p>
                </div>
              </div>
            </div>

            {/* Bonos GRATIS */}
            <div className="bg-gradient-to-r from-[#FFFDF5] to-[#FFF9E6] rounded-xl p-4 border-2 border-[#F5C842]/30 mb-5" data-id="element-328">
              <div className="flex items-center gap-2 mb-3" data-id="element-329">
                <Gift className="w-5 h-5 text-[#E8845F]" data-id="element-330" />
                <span className="font-bold text-gray-800 text-sm" data-id="element-331">
                  + 3 Bonos GRATIS (valor $47)
                </span>
              </div>
              <div className="space-y-2" data-id="element-332">
                {bonusDetails.map(bonus => {
                const IconComponent = bonus.icon;
                const colorClass = bonus.color === 'teal' ? 'text-[#4AAAA5]' : bonus.color === 'coral' ? 'text-[#E8845F]' : 'text-[#D4A72C]';
                return <div key={bonus.id} className="flex items-center gap-2" data-id="element-333">
                      <div className="w-5 h-5 rounded-full bg-white flex items-center justify-center shadow-sm" data-id="element-334">
                        <IconComponent className={`w-3 h-3 ${colorClass}`} data-id="element-335" />
                      </div>
                      <span className="text-gray-700 text-xs flex-1" data-id="element-336">
                        {bonus.title}
                      </span>
                      <span className="text-gray-400 text-xs line-through" data-id="element-337">
                        {bonus.value}
                      </span>
                      <span className="text-[#4AAAA5] text-xs font-bold" data-id="element-338">
                        $0
                      </span>
                    </div>;
              })}
              </div>

              {/* Ver más button */}
              <button onClick={() => setShowBonusDetails(!showBonusDetails)} className="w-full mt-3 pt-3 border-t border-[#F5C842]/30 flex items-center justify-center gap-1 text-[#E8845F] font-semibold text-sm hover:text-[#D4733E] transition-colors" data-id="element-339">
                {showBonusDetails ? <>
                    Ver menos
                    <ChevronUp className="w-4 h-4" data-id="element-340" />
                  </> : <>
                    Ver más detalles
                    <ChevronDown className="w-4 h-4" data-id="element-341" />
                  </>}
              </button>

              {/* Expanded bonus details */}
              {showBonusDetails && <div className="mt-4 space-y-4 animate-in slide-in-from-top-2 duration-300" data-id="element-342">
                  {bonusDetails.map(bonus => {
                const styles = colorStyles[bonus.color];
                return <div key={bonus.id} className={`${styles.bg} rounded-xl p-4 border ${styles.border}`} data-id="element-343">
                        <div className="flex gap-3" data-id="element-344">
                          {/* Mini image */}
                          <div className="flex-shrink-0 w-20 h-20 rounded-lg overflow-hidden shadow-md" data-id="element-345">
                            <img src={bonus.image} alt={bonus.title} className="w-full h-full object-cover" data-id="element-346" />
                          </div>

                          {/* Content */}
                          <div className="flex-1 min-w-0" data-id="element-347">
                            <div className="flex items-center gap-1 mb-1" data-id="element-348">
                              <Gift className={`w-3 h-3 ${styles.icon}`} data-id="element-349" />
                              <span className={`text-xs font-bold ${styles.icon} uppercase`} data-id="element-350">
                                {bonus.subtitle}
                              </span>
                            </div>
                            <h4 className="font-bold text-gray-800 text-sm leading-tight mb-1" data-id="element-351">
                              {bonus.title}
                            </h4>
                            <p className="text-gray-600 text-xs leading-relaxed" data-id="element-352">
                              {bonus.description}
                            </p>
                          </div>
                        </div>

                        {/* Benefits */}
                        <div className="mt-3 pt-3 border-t border-white/50 space-y-1.5" data-id="element-353">
                          <p className="text-xs font-bold text-gray-700" data-id="element-354">
                            Te ayuda a:
                          </p>
                          {bonus.benefits.map((benefit, idx) => <div key={idx} className="flex items-start gap-2" data-id="element-355">
                              <div className={`w-4 h-4 rounded-full ${styles.badge} flex items-center justify-center flex-shrink-0 mt-0.5`} data-id="element-356">
                                <Check className="w-2.5 h-2.5 text-white" data-id="element-357" />
                              </div>
                              <span className="text-gray-700 text-xs" data-id="element-358">
                                {benefit}
                              </span>
                            </div>)}
                        </div>
                      </div>;
              })}
                </div>}
            </div>

            <Button className="w-full text-lg shadow-xl" size="lg" withIcon onClick={handleBuyClick} trackAddToCart={true} data-id="element-359">
              Sí, lo quiero ahora
            </Button>

            <p className="text-center text-xs text-gray-400 mt-4 flex items-center justify-center gap-2" data-id="element-360">
              <Shield className="w-3 h-3" data-id="element-361" />
              Pago seguro • Entrega digital inmediata
            </p>
          </div>
        </div>

        {/* Countdown Timer */}
        <CountdownTimer initialMinutes={15} data-id="element-362" />

        {/* Guarantee */}
        <div className="mt-8 bg-white/80 backdrop-blur-sm rounded-2xl p-6 border-2 border-[#4AAAA5]/20 text-center" data-id="element-363">
          <div className="flex items-center justify-center mb-3" data-id="element-364">
            <Shield className="w-8 h-8 text-[#4AAAA5] mr-2" data-id="element-365" />
            <span className="font-bold text-gray-800 text-lg" data-id="element-366">
              Garantía de 30 días
            </span>
          </div>
          <p className="text-gray-600 text-sm" data-id="element-367">
            Pruébalo sin riesgo. Si no es para ti, te devolvemos tu dinero.
          </p>
        </div>

        {/* Emotional close */}
        <div className="mt-10 text-center space-y-5" data-id="element-368">
          <h3 className="text-xl md:text-2xl font-extrabold text-gray-800 leading-snug" data-id="element-369">
            No necesitas una casa perfecta.
            <br data-id="element-370" />
            <span className="text-[#4AAAA5]" data-id="element-371">
              Necesitas una mañana que no te rompa.
            </span>
          </h3>
          <p className="text-gray-600 text-lg" data-id="element-372">
            Dale a tu hijo una estructura que pueda ver… y recupérate tú en el
            proceso.
          </p>
        </div>
      </div>
    </Section>;
}